import type { ComponentPropsWithoutRef } from 'react';
import styled from '@emotion/styled';
import Skeleton from '@mui/material/Skeleton';

// Stands in for the chat itself (message track and composer) while the panel's header and topic
// row stay on screen, and fills the rest of the panel's column. Also the body of the full-panel
// placeholder, so the two lay out identically.
export const ChatTrackSkeleton = (props: ComponentPropsWithoutRef<'div'>) => (
  <TrackRoot {...props}>
    <MessageRow style={{ gap: '20px' }}>
      <Skeleton variant="circular" width={38} height={38} />
      <Bubble>
        <Skeleton variant="rounded" width="96%" height={26} style={{ marginBottom: '5px' }} />
        <Skeleton variant="rounded" width="88%" height={26} style={{ marginBottom: '5px' }} />
        <Skeleton variant="rounded" width="88%" height={26} style={{ marginBottom: '5px' }} />
        <Skeleton variant="rounded" width="88%" height={26} style={{ marginBottom: '5px' }} />
      </Bubble>
    </MessageRow>
    <FooterRow>
      <InputRow>
        <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end', paddingBottom: '5px' }}>
          <Skeleton variant="circular" width={38} height={38} />
          <Skeleton variant="circular" width={38} height={38} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <Skeleton variant="rounded" width={24} height={24} />
            <Skeleton variant="rounded" width={24} height={24} />
          </div>
          <Skeleton variant="rounded" width="40px" height={24} />
        </div>
      </InputRow>
    </FooterRow>
  </TrackRoot>
);

const TrackRoot = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
  min-width: 0;
`;

const MessageRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const Bubble = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  border: 2px solid var(--gray-xl);
  border-radius: 6px;
  background-color: var(--pri-01);
`;

const FooterRow = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 25px;
`;

const InputRow = styled.div`
  padding: 14px 14px 0;
  border: 2px solid var(--gray-xl);
  width: 100%;
  height: 80px;
  border-radius: 6px;
`;
